export function getView(list) {
  return list?.filter(
    image =>
      (!image.slot_key || image.type_key === 'misc') &&
      !image.mime_type?.startsWith('video/')
  ).length
    ? 'Content'
    : 'Empty'
}
